// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--c07ca";
export var carousel = "style-module--carousel--ab315";
export var carouselContainer = "style-module--carouselContainer--c0ca1";
export var container = "style-module--container--8a755";
export var detailed = "style-module--detailed--0a655";
export var fadeIn = "style-module--fadeIn--a9512";
export var instagram = "style-module--instagram--41ce7";
export var item = "style-module--item--4d233";